import React, { useEffect, useRef, useState } from "react";
import { FormGrid } from "mesh-component-library";
import { LocationInput } from "./components/LocationInput";
import { RequestGoogleNearbySearchPayload } from "../../types";
import Spinner from "../../components/spinner";
import { BodyContainer, HiddenGoogleMap, StyledFormGrid } from "./DropoffLocationSelection.styles";
import { DetailedLocationReviewV2, ListView } from "./components";
import { ToggleView } from "./components/ToggleView";

export type DropoffLocationSelectionProps = {
  appId: string;
  currentGeoCoordinates: {
    lat: google.maps.LatLngLiteral["lat"];
    lng: google.maps.LatLngLiteral["lng"];
  };
  isDropoffLocationFocused: boolean;
  loading: boolean;
  onInit: (data: RequestGoogleNearbySearchPayload) => void;
  view: "list" | "map";
};

export const DropoffLocationSelection = ({
  appId,
  currentGeoCoordinates,
  isDropoffLocationFocused,
  loading,
  onInit,
  view,
}: DropoffLocationSelectionProps) => {
  // Until we have completely migrated to the new UI for dropoff location selection,
  // we will use the temporary redux store with LocationRouter
  // const [view, setView] = useState<"list" | "map">("list");
  const [map, setMap] = useState(null);
  const [service, setService] = useState(null);
  const mapRef = useRef();

  // Instantiate Place Service & request locations (onInit)
  useEffect(() => {
    const map = new google.maps.Map(mapRef.current);
    const placeService = new google.maps.places.PlacesService(map);

    setMap(map);
    setService(placeService);
    onInit({
      placeService,
      location: currentGeoCoordinates,
      appId: appId,
    });
  }, []);

  return (
    <>
      {isDropoffLocationFocused && <DetailedLocationReviewV2 service={service}/>}
      <StyledFormGrid>
        <FormGrid.Column>
          <LocationInput map={mapRef.current} />
        </FormGrid.Column>
        <FormGrid.Column>
          <ToggleView />
        </FormGrid.Column>
      </StyledFormGrid>
      <BodyContainer>
        {loading && <Spinner />}
        {!loading && view === "list" && <ListView service={service} />}
        <HiddenGoogleMap ref={mapRef} />
      </BodyContainer>
    </>
  );
};
